export default "__VITE_ASSET__3074a391__"